export const AUTH_SERVICE_ENDPOINT = window.env.VUE_APP_AUTH_SERVICE_DOMAIN;

// Resource paths
export const TOKEN_RESOURCE_PATH = '/token';
export const CONFIRMATION_CODE_RESOURCE_PATH = '/confirmation_code';
export const FORGOT_PASSWORD_RESOURCE_PATH = '/reset';
export const RESET_PASSWORD_RESOURCE_PATH = '/reset_password';
